import { render, staticRenderFns } from "./TraxAccountUserEditAccess.vue?vue&type=template&id=030d1850"
import script from "./TraxAccountUserEditAccess.vue?vue&type=script&lang=js"
export * from "./TraxAccountUserEditAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports